import { IntlContext } from "context";
import React, { useContext } from "react";
import { PrimitiveType } from "intl-messageformat";
import Input from "ui/Form/Element/Input";

type FormatXMLElementFn = (
    ...args: Array<string | React.ReactNode>
) => string | Array<string | React.ReactNode> | JSX.Element;

export interface LabelProps {
    name: string;
    props: Record<string, PrimitiveType | React.ReactElement | FormatXMLElementFn>;
}

export interface SliderProps {
    id?: string;
    disabled?: boolean;
    className?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    required?: boolean;
    groupClassName?: string;
    labelClassName?: string;
    name: string;
    step?: number;
    value?: number;
    min?: number;
    max?: number;
    unit?: string;
    label?: LabelProps;
}

const Slider: React.FC<SliderProps> = ({
    groupClassName,
    value = 0,
    min = 0,
    max = 100,
    unit = "",
    label,
    disabled,
    className = "field__slider-input w-full",
    onChange,
    ...props
}) => {
    const intl = useContext(IntlContext);
    let rangeValue = value ?? min;

    let newValue = ((rangeValue - min) * 100) / (max - min);
    let newPosition = 10 - newValue * 0.2;
    let left = `calc(${newValue}% + (${newPosition}px))`;

    return (
        <div className={groupClassName}>
            {label !== undefined && intl.formatMessage(label.name, label.props)}
            <div className="field__slider-range flex justify-between">
                <span className="field__slider-min">
                    {min} {unit}
                </span>
                <span className="field__slider-max">
                    {max} {unit}
                </span>
            </div>
            <Input
                type="range"
                min={min}
                max={max}
                value={value}
                disabled={disabled}
                onChange={disabled ? undefined : onChange}
                className={`${className}${disabled ? " pointer-events-none cursor-not-allowed opacity-50" : ""}`}
                {...props}
            />
            <div
                className="field__slider-value"
                style={{
                    left: left,
                    display: "none",
                }}
            >
                <span className="field__slider-value--inner">
                    {rangeValue} {unit}
                </span>
            </div>
        </div>
    );
};

Slider.defaultProps = {
    className: "field__slider-input w-full",
    groupClassName: "field__slider-group",
};

export default Slider;
